import React, { useState, useEffect } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation, Link, useHistory } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faUser,
  faCreditCard,
  faBuilding,
  faUsers,
  faCogs,
  faDesktop,
  faChartBar,
  faTimes,
  faWallet,
  faCaretDown
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Button, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Routes } from "../routes";
import { client } from "../api/client";
import { getStoredUser, isAdmin, isSupervisor, canSeeSection, hasAccess, hasAnyAccess, updateFaviconAndTitle } from "../utils/access";

export default (props = {}) => {
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";
  const [user, setUser] = useState(() => getStoredUser());

  const onCollapse = () => setShow(!show);

  const handleLogout = () => {
    const token = localStorage.getItem("access_token");
    const API_BASE = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? window.location.origin : 'https://sgrloto.com';
    if (token) {
      fetch(`${API_BASE}/api/logout/`, {
        method: "POST",
        headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        body: "{}",
      }).catch(() => {});
    }
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_profile");
    history.push(Routes.Signin.path);
  };

  const [companyName, setCompanyName] = useState("DISIP LOTTO");
  const [companyLogo, setCompanyLogo] = useState(null);

  useEffect(() => {
    const userProfileStr = localStorage.getItem("user_profile");
    if (userProfileStr) {
      try {
        const userProfile = JSON.parse(userProfileStr);
        setUser(userProfile);
        updateFaviconAndTitle(userProfile);
        if (userProfile?.company?.name) {
          setCompanyName(userProfile.company.name);
        }
        if (userProfile?.company?.logo) {
          setCompanyLogo(userProfile.company.logo);
        }
      } catch (e) {
        console.error("Error parsing user profile from localStorage:", e);
      }
    }

    const fetchFreshProfile = async () => {
      try {
        const profile = await client("me/");
        if (profile) {
          localStorage.setItem("user_profile", JSON.stringify(profile));
          setUser(profile);
          updateFaviconAndTitle(profile);
          if (profile.company?.name) {
            setCompanyName(profile.company.name);
          }
          if (profile.company?.logo) {
            setCompanyLogo(profile.company.logo);
          }
        }
      } catch (err) {
        console.error("Failed to fetch fresh user profile:", err);
      }
    };

    fetchFreshProfile();
  }, []);

  const getAbsoluteLogoUrl = (logoPath) => {
    if (!logoPath) return null;
    if (logoPath.startsWith("http://") || logoPath.startsWith("https://")) {
      return logoPath;
    }
    const backendHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
      ? 'http://localhost:8000' 
      : window.location.origin;
    
    return logoPath.startsWith('/') ? `${backendHost}${logoPath}` : `${backendHost}/${logoPath}`;
  };

  const logoUrl = getAbsoluteLogoUrl(companyLogo);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey} style={{ backgroundColor: 'transparent', border: 'none' }}>
          <Accordion.Button
            as={Nav.Link}
            className="d-flex justify-content-between align-items-center sidebar-link-custom"
            style={{
              color: '#FFFFFF',
              padding: '8px 12px',
              borderRadius: '6px',
              fontSize: '0.88rem',
              backgroundColor: defaultKey ? '#2B384E' : 'transparent',
              transition: 'all 0.2s ease',
              boxShadow: 'none'
            }}
          >
            <span className="d-flex align-items-center w-100">
              <FontAwesomeIcon icon={icon} style={{ color: '#FF4500', marginRight: '10px', width: '16px' }} />
              <span className="sidebar-text" style={{ color: '#FFFFFF', marginRight: '6px' }}>{title}</span>
              <FontAwesomeIcon icon={faCaretDown} className="link-arrow ms-auto" style={{ color: '#FF4500', fontSize: '0.8rem' }} />
            </span>
          </Accordion.Button>
          <Accordion.Body style={{ backgroundColor: 'transparent', padding: '4px 0 4px 20px' }}>
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const SubNavItem = (props) => {
    const { title, link } = props;
    const linkProps = { as: Link, to: link };

    return (
      <Nav.Item onClick={() => setShow(false)}>
        <Nav.Link 
          {...linkProps} 
          className="sidebar-sublink-custom d-flex align-items-center"
          style={{ 
            color: '#C8C8C8', 
            padding: '5px 12px', 
            fontSize: '0.82rem',
            transition: 'all 0.2s ease'
          }}
        >
          <span style={{ color: '#FF4500', marginRight: '8px', fontSize: '0.65rem' }}>▶</span>
          <span className="sidebar-text">{title}</span>
        </Nav.Link>
      </Nav.Item>
    );
  };

  const NavItem = (props) => {
    const { title, link, icon, badgeText, onClick } = props;
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = link ? { as: Link, to: link } : {};
    const isActive = link === pathname;

    return (
      <Nav.Item className={navItemClassName} onClick={() => { if (onClick) onClick(); setShow(false); }}>
        <Nav.Link
          {...linkProps}
          className="sidebar-link-custom"
          style={{
            color: '#FFFFFF',
            padding: '8px 12px',
            fontSize: '0.88rem',
            borderRadius: '6px',
            backgroundColor: isActive ? '#2B384E' : 'transparent',
            transition: 'all 0.2s ease'
          }}
        >
          <span className="d-flex align-items-center">
            {icon && <FontAwesomeIcon icon={icon} style={{ color: '#FF4500', marginRight: '10px', width: '16px' }} />}
            <span className="sidebar-text">{title}</span>
            {badgeText && <span className="badge bg-secondary ms-auto sidebar-text">{badgeText}</span>}
          </span>
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <style>{`
        /* Remove fine borders on sidebar items */
        .sidebar .nav-item,
        .sidebar .nav-link,
        .sidebar .nav-item.active > .nav-link,
        .sidebar .accordion-item,
        .sidebar .accordion-button,
        .sidebar-link-custom,
        .sidebar-sublink-custom {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }

        /* Remove default bootstrap accordion arrow */
        .accordion-button::after {
          display: none !important;
        }
        .sidebar-link-custom:hover {
          background-color: #2B384E !important;
          color: #FFFFFF !important;
        }
        .sidebar-sublink-custom:hover {
          color: #FF4500 !important;
          padding-left: 16px !important;
        }
        
        /* Smooth transitions for contracted/collapsed state */
        .sidebar.contracted {
          max-width: 70px !important;
          width: 70px !important;
        }
        .sidebar.contracted .sidebar-text,
        .sidebar.contracted .link-arrow,
        .sidebar.contracted .badge {
          opacity: 0 !important;
          display: none !important;
        }
        .sidebar.contracted .sidebar-inner {
          padding-left: 5px !important;
          padding-right: 5px !important;
        }
        .sidebar.contracted .accordion-body {
          display: none !important;
        }
        
        /* Adjust layout spacing when collapsed */
        @media (min-width: 768px) {
          .content.collapsed {
            margin-left: 70px !important;
          }
        }
      `}</style>

      <Navbar expand={false} collapseOnSelect variant="dark" className="px-3 d-md-none" style={{ backgroundColor: '#1D283A' }}>
        <div className="d-flex align-items-center justify-content-start gap-3 w-100">
          <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse} className="p-1 border-0">
            <span className="navbar-toggler-icon" />
          </Navbar.Toggle>
          <Navbar.Brand as={Link} to={Routes.DashboardOverview.path} className="m-0">
            <span className="fw-bold text-white fs-6">{companyName}</span>
          </Navbar.Brand>
        </div>
      </Navbar>
      {show && (
        <div 
          className="d-md-none position-fixed top-0 start-0 w-100 h-100" 
          style={{ backgroundColor: 'rgba(0,0,0,0.4)', zIndex: 99, backdropFilter: 'blur(2px)' }}
          onClick={onCollapse}
        />
      )}
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block text-white ${props.collapsed ? 'contracted' : ''}`} style={{ backgroundColor: '#1D283A' }}>
          <div className="sidebar-inner px-3 pt-3">
            {/* Logo + Title */}
            <div style={{ textAlign: 'center', padding: '12px 0 16px 0' }}>
              {logoUrl ? (
                <div style={{ marginBottom: '8px' }}>
                  <img 
                    src={logoUrl} 
                    alt="Logo" 
                    style={{ 
                      maxWidth: '65px', 
                      maxHeight: '65px', 
                      borderRadius: '8px', 
                      objectFit: 'contain',
                      backgroundColor: '#FFFFFF',
                      padding: '4px'
                    }} 
                  />
                </div>
              ) : (
                <div style={{ fontSize: '2.5rem', lineHeight: 1, marginBottom: '4px' }}>🐓</div>
              )}
              <h5 className="sidebar-text" style={{ fontWeight: 'bold', color: '#FFFFFF', margin: 0, letterSpacing: '1px' }}>{companyName}</h5>
            </div>

            {/* Mobile close */}
            <div className="user-card d-flex d-md-none align-items-center justify-content-end py-2">
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} style={{ color: '#FFFFFF' }} />
              </Nav.Link>
            </div>

            {/* Navigation */}
            <Nav className="flex-column" style={{ marginTop: '12px' }}>
              {canSeeSection("0", ["0.1", "0.2", "0.3", "0.4", "0.5", "0.6"], user) && (
                <NavItem title="Tableau de bord" link={Routes.DashboardOverview.path} icon={faHome} onClick={() => window.dispatchEvent(new Event("resetDashboardView"))} />
              )}
              <NavItem title="Mon compte" link={Routes.Settings.path} icon={faUser} />
              {(isAdmin(user) || hasAnyAccess(["0.6", "3.4"], user)) && (
                <NavItem title="Succursal" link={Routes.Branches.path} icon={faBuilding} />
              )}
              {canSeeSection("1", ["1.1", "1.2", "1.3", "1.4", "2", "2.1", "2.2", "2.3", "2.4", "2.5", "2.6", "2.7", "2.8", "2.9"], user) && (
                <NavItem title="Agents / POS" link={Routes.Agents.path} icon={faUsers} badgeText="📋" />
              )}

              {canSeeSection("3", ["3.3", "3.4", "3.5", "3.6", "3.7", "3.8"], user) && (
                <CollapsableNavItem eventKey="configurations/" title="Configurations" icon={faCogs}>
                  {(isAdmin(user) || hasAccess("3.8", user)) && (
                    <SubNavItem title="Mariage gratuit" link={Routes.MariageGratuit.path} />
                  )}
                  {(isAdmin(user) || hasAccess("3.7", user)) && (
                    <SubNavItem title="Tirages" link={Routes.Tirages.path} />
                  )}
                  {(isAdmin(user) || hasAccess("3.5", user)) && (
                    <SubNavItem title="Primes" link={Routes.Primes.path} />
                  )}
                  {isAdmin(user) && (
                    <SubNavItem title="Utilisateurs" link="#utilisateurs" />
                  )}
                </CollapsableNavItem>
              )}

              {canSeeSection("4", ["4.1", "4.2", "4.3", "4.4", "4.5", "4.6", "4.7", "4.8"], user) && (
                <CollapsableNavItem eventKey="surveillance/" title="Surveillance" icon={faDesktop}>
                  {(isAdmin(user) || hasAnyAccess(["4.1", "4.2"], user)) && (
                    <SubNavItem title="Statistiques" link={Routes.Statistiques.path} />
                  )}
                  {(isAdmin(user) || hasAnyAccess(["4.6", "4.6.1", "4.6.2"], user)) && (
                    <SubNavItem title="Blocage boule" link={Routes.BlocageBoule.path} />
                  )}
                  {(isAdmin(user) || hasAnyAccess(["4.6", "4.6.1", "4.6.2"], user)) && (
                    <SubNavItem title="Limite boule" link={Routes.LimiteBoule.path} />
                  )}
                  {(isAdmin(user) || hasAnyAccess(["4.7", "4.7.1", "4.7.2", "4.7.3"], user)) && (
                    <SubNavItem title="Limites" link={Routes.Limites.path} />
                  )}
                  {(isAdmin(user) || hasAnyAccess(["4.8", "4.8.1", "4.8.2", "4.8.3", "4.8.4"], user)) && (
                    <SubNavItem title="Controle agent" link="#controle-agent" />
                  )}
                  {(isAdmin(user) || hasAccess("4.4", user)) && (
                    <SubNavItem title="Lots gagnant" link={Routes.LotsGagnant.path} />
                  )}
                  {(isAdmin(user) || hasAccess("4.5", user)) && (
                    <SubNavItem title="Traçabilité" link={Routes.Tracabilite.path} />
                  )}
                  {isAdmin(user) && (
                    <>
                      <SubNavItem title="Fiches par agent" link="#fiches-par-agent" />
                      <SubNavItem title="Demmande élimination" link="#demmande-elimination" />
                    </>
                  )}
                </CollapsableNavItem>
              )}

              {canSeeSection("5", ["5.1", "5.2", "5.3", "5.4", "5.5"], user) && (
                <CollapsableNavItem eventKey="rapport/" title="Rapport" icon={faChartBar}>
                  {(isAdmin(user) || hasAnyAccess(["5", "5.1"], user)) && (
                    <>
                      <SubNavItem title="Journalier" link={Routes.RapportJournalier.path} />
                      <SubNavItem title="Général" link={Routes.RapportGeneral.path} />
                    </>
                  )}
                  {(isAdmin(user) || hasAccess("5.2", user)) && (
                    <SubNavItem title="Fiches vendues" link={Routes.RapportFichesVendues.path} />
                  )}
                  {(isAdmin(user) || hasAccess("5.3", user)) && (
                    <SubNavItem title="Fiches gagnantes" link={Routes.RapportFichesGagnantes.path} />
                  )}
                  {(isAdmin(user) || hasAccess("5.4", user)) && (
                    <SubNavItem title="Fiches éliminées" link={Routes.RapportFichesEliminees.path} />
                  )}
                </CollapsableNavItem>
              )}

              {isSupervisor(user) && (
                <div className="mt-3 px-2">
                  <div style={{ fontSize: '0.7rem', color: '#8899AA', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Superviseur
                  </div>
                  <div style={{ fontSize: '0.78rem', color: '#C8C8C8', marginTop: '2px' }}>
                    {user?.branch_name || user?.supervised_branches?.[0]?.name || "—"}
                  </div>
                </div>
              )}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
